// ********************************************************************************
// Wheels service can either be a pickup or a dropoff service. The direction field
//  is a string that can be either a "northbound" when coming from CBX or a 
// "southbound" when going to CBX.  The direction field is a required and is set 
// based on the user's input. 
export enum WheelsDirection {
  FromCBX = 'northbound',
  ToCBX = 'southbound',
}